import { useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  FieldWrapper,
  FormTextField,
  PasswordFieldInputAdornment,
} from "styles/formStyleComponents";
import InfoIconWithTooltip from "./InfoIconWithTooltip";

const PasswordFieldComponent = ({
  name,
  label,
  placeholder,
  value,
  required,
  disabled,
  error,
  info,
  field = {},
  onChange,
  onFieldBlur,
  validation = {},
  compact = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const hideLabel = field.hideLabel === true || compact;
  const tooltipInfo = info || field.info;
  const autoComplete = field.autoComplete ?? "new-password";
  const showToggle = field.showPasswordToggle !== false;

  const textField = (
    <FormTextField
      label={hideLabel ? undefined : label}
      variant="outlined"
      size="small"
      fullWidth
      required={required}
      disabled={disabled}
      placeholder={placeholder}
      type={showPassword ? "text" : "password"}
      value={value || ""}
      onChange={(e) => {
        const val = e.target.value;
        if (validation.maxLength && val.length > validation.maxLength) {
          return;
        }
        onChange(name, val);
      }}
      onBlur={(e) => {
        if (onFieldBlur) {
          onFieldBlur(name, e.target.value);
        }
      }}
      error={!!error}
      helperText={error}
      autoComplete={autoComplete}
      slotProps={{
        htmlInput: {
          maxLength: validation.maxLength,
        },
      }}
      InputProps={{
        endAdornment: (
          <PasswordFieldInputAdornment position="end">
            <InfoIconWithTooltip info={tooltipInfo} />
            {showToggle && (
              <IconButton
                onClick={() => setShowPassword((prev) => !prev)}
                onMouseDown={(e) => e.preventDefault()}
                edge="end"
                aria-label={showPassword ? "Hide password" : "Show password"}
                disabled={disabled}
                size="small"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            )}
          </PasswordFieldInputAdornment>
        ),
      }}
    />
  );

  const content = textField;

  if (compact) {
    return <Box>{content}</Box>;
  }

  return <FieldWrapper>{content}</FieldWrapper>;
};

export default PasswordFieldComponent;
